import React, { useState } from 'react';
import BusDialog from './BusDialog';
import { BusFormValues, EnrolBusDialogProps } from '../types/busTypes';
import { enrolBus } from '../utils/utils';
import { SnackbarSeverityType } from '../../../enums';

const EnrolBusDialog: React.FC<EnrolBusDialogProps> = ({
  open,
  schoolId,
  onClose,
  onSuccess,
  showToast
}) => {
  const initialValues: BusFormValues = { name: '', licensePlateNo: '' };
  const [values, setValues] = useState<BusFormValues>(initialValues);
  const [errors, setErrors] = useState<
    Partial<Record<keyof BusFormValues, string>>
  >({});
  const [loading, setLoading] = useState(false);

  const handleChange = (field: keyof BusFormValues, value: string) => {
    setValues((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => {
      const next = { ...prev };
      if (value.trim()) {
        delete next[field];
      }
      return next;
    });
  };

  const handleSubmit = async () => {
    if (!schoolId) {
      showToast('Missing school id', SnackbarSeverityType.error);
      return;
    }
    try {
      setLoading(true);
      const result = await enrolBus(values, schoolId);
      if (!result.ok) {
        setErrors(result.errors || {});
        const firstError = result.errors && Object.values(result.errors)[0];
        showToast(
          firstError || 'Failed to enroll bus',
          SnackbarSeverityType.error
        );
        return;
      }
      setErrors({});
      showToast('Bus enrolled', SnackbarSeverityType.success);
      setValues(initialValues);
      onClose();
      onSuccess();
    } catch (e: any) {
      showToast(
        e?.message || 'Failed to enrol bus',
        SnackbarSeverityType.error
      );
    } finally {
      setLoading(false);
    }
  };

  const handleDialogClose = () => {
    if (loading) return;
    setValues(initialValues);
    setErrors({});
    onClose();
  };

  return (
    <BusDialog
      open={open}
      values={values}
      errors={errors}
      loading={loading}
      onClose={handleDialogClose}
      onChange={handleChange}
      onSubmit={handleSubmit}
      submitLabel='Submit'
    />
  );
};

export default EnrolBusDialog;
